import { Column, TableLazyLoadEvent } from "../models"

export interface ColumnFilter {
    field: string
    value: string
    matchMode: string
}

export interface PagedParams {
    search?: string
    sortField?: string
    sortDescending: boolean
    page: number
    pageSize: number
    columnFilters: ColumnFilter[]
}


export type ResolveCats = (names: string[]) => ColumnFilter | null

export function toPagedParams(event: TableLazyLoadEvent, cols: Column[], resolveCats?: ResolveCats): PagedParams {
    const rows = event.rows ?? 10
    const page = Math.floor((event.first ?? 0) / rows) + 1
    const sortField = Array.isArray(event.sortField) ? event.sortField[0] : event.sortField ?? undefined
    const sortDescending = (event.sortOrder ?? -1) < 0
    const search = typeof event.globalFilter === "string" ? event.globalFilter : undefined

    return {
        search,
        sortField,
        sortDescending,
        page,
        pageSize: rows,
        columnFilters: buildColumnFilters(event, cols, resolveCats),
    }
}

export function buildColumnFilters(
    event: TableLazyLoadEvent,
    cols: Column[],
    resolveCats?: ResolveCats
): ColumnFilter[] {
    const filters: ColumnFilter[] = []

    for (const col of cols) {
        if (!col.filterType) continue
        const key = col.subField ? `${col.field}.${col.subField}` : col.field
        const meta = event.filters?.[key]
        const single = Array.isArray(meta) ? meta[0] : meta
        const value = single?.value
        if (value === undefined || value === null || value === "") continue

        if (col.filterType === "cats") {
            const names: string[] = Array.isArray(value) ? value : [value]
            const filter = resolveCats?.(names)
            if (filter) filters.push(filter)
            continue
        }

        
        if (col.filterType === "locs" || col.filterType === "states") continue

        const matchMode =
            col.filterMode ??
            (col.filterType === "text" ? "contains" : col.filterType === "date" ? "dateIs" : "equals")

        filters.push({
            field: key,
            value: value instanceof Date ? value.toISOString() : String(value),
            matchMode,
        })
    }

    return filters
}
